import "discourse/lib/load-moment";
import jQuery from "jquery";

if (!window.$) {
  window.$ = window.jQuery = jQuery;
}
